import { useEffect } from 'react';
import { AuditResult } from '@blisspointmedia/bpm-types/dist/GoogleAdsAudit';
import { Button } from '@Components/Button';
import { Design, Size } from '@Components/designConstants';
import { AuditResults } from './AuditResults';

interface PrintViewProps {
  accountName: string;
  runDate: string;
  results: AuditResult[];
  onClose: () => void;
}

// A full-page overlay rendered in place of the workspace (rather than a separate route —
// this page has no nested routing, unlike bliss-audit's Next.js /print route) with
// print-only CSS hiding the app chrome and action buttons via .no-print.
export const PrintView = ({ accountName, runDate, results, onClose }: PrintViewProps) => {
  useEffect(() => {
    const timeout = setTimeout(() => window.print(), 400);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className='google-ads-audit-print-view'>
      <div className='google-ads-audit-print-actions no-print'>
        <Button size={Size.SM} onClick={() => window.print()}>
          Save as PDF
        </Button>
        <Button design={Design.NEUTRAL} size={Size.SM} onClick={onClose}>
          Close
        </Button>
      </div>
      <div className='google-ads-audit-print-header'>
        <h1>{accountName} — Google Ads Audit</h1>
        <p>
          {new Date(runDate).toLocaleDateString('en-US', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
          })}
        </p>
      </div>
      <AuditResults results={results} />
    </div>
  );
};
